module.exports = "<p>{{ title }}</p>\n<p>{{ message }}</p>\n\n<button type=\"button\" mat-raised-button\n    (click)=\"dialogRef.close(true)\">OK</button>\n<button type=\"button\" mat-button\n    (click)=\"dialogRef.close()\">Cancel</button>\n"


//////////////////
// WEBPACK FOOTER
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/confirm-dialog/confirm-dialog.component.html
// module id = ../../../../../src/app/shared/components/confirm-dialog/confirm-dialog.component.html
// module chunks = main